import { ReactComponent as HomeIcon } from "../../assets/icons/HomeDisabled.svg";
import { ReactComponent as CoachesIcon } from "../../assets/icons/CashDisabled.svg";
import { ReactComponent as UserDisabledIcon } from "../../assets/icons/UserDisabled.svg";
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import {
  StyledSider,
  StyledLasuLogo,
  LogoText,
  LogoWrapper,
  CollapseButton,
  StyledMenu,
  StyledMenuItem,
  SidebarHeader,
  StyledLastMenuItem,
} from "./style";
import { ReactComponent as SettingsIcon } from "../../assets/icons/Settings.svg";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../routes";
import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "antd";
import { useAppDispatch, useAppSelector } from "../../store/config";
import { authLogoutStart } from "../../store/features/auth/auth-slice";

const SideBar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const { user } = useAppSelector((state) => state.auth);

  const items = [
    {
      key: "users",
      label: t("Users"),
      icon: UserDisabledIcon,
      to: routes.appRoutes.users,
    },
    {
      key: "coaches",
      label: t("Trainers"),
      icon: CoachesIcon,
      to: routes.appRoutes.trainers,
    },
    {
      key: "diet",
      label: t("Diet"),
      icon: HomeIcon,
      to: routes.appRoutes.diet,
    },
  ];

  const getSelectedKey = () => {
    const path = location.pathname;
    if (!path || path === "/" || path === "") return "users";
    const matchingItem = items.find((item) => path.startsWith(item.to));
    return matchingItem ? matchingItem.key : "users"; // Default to 'dashboard' if no match
  };

  const [selectedKey, setSelectedKey] = useState<string>(getSelectedKey());
  useEffect(() => {
    setSelectedKey(getSelectedKey());
  }, [location]); // Update selectedKey when location changes

  useEffect(() => {
    if (user.role !== "admin") setCollapsed(true);
  }, [user]);

  const handleMenuClick = (e: any) => {
    setSelectedKey(e.key); // Update selectedKey based on the clicked item
  };

  const handleLogOut = () => {
    dispatch(authLogoutStart());
  };

  return (
    <StyledSider
      width={"15rem"}
      collapsedWidth={"5rem"}
      collapsible={true}
      collapsed={collapsed}
      trigger={null}
    >
      <SidebarHeader className={`${collapsed ? "collapsed" : ""}`}>
        <LogoWrapper
          style={{
            opacity: collapsed ? 0 : 1,
            maxHeight: collapsed ? "0px" : "33px", // Smooth height collapse
            width: collapsed ? "0px" : "auto", // Smooth width collapse
          }}
        >
          <LogoText>
            <StyledLasuLogo /> {t("Lasu")}
          </LogoText>
        </LogoWrapper>
        <CollapseButton
          type="text"
          icon={collapsed ? <DoubleLeftOutlined /> : <DoubleRightOutlined />}
          onClick={() => setCollapsed(!collapsed)}
        />
      </SidebarHeader>
      <StyledMenu
        mode="inline"
        selectedKeys={[selectedKey]}
        onClick={handleMenuClick}
      >
        {user.role === "admin" &&
          items.map((item) => (
            <StyledMenuItem
              $isSelected={selectedKey === item.key}
              icon={<item.icon />}
              key={item.key}
            >
              <Link to={item.to}>{item.label}</Link>
            </StyledMenuItem>
          ))}
        {/* <StyledLastMenuItem $isSelected={selectedKey === 'settings'}  icon={<SettingsIcon />} key="settings">
                    <Link to={'/settings'}>{t('Settings')}</Link>
                </StyledLastMenuItem> */}
        <StyledLastMenuItem
          $isSelected={false}
          icon={<LogoutOutlined />}
          key="logout"
          onClick={handleLogOut}
        >
          <Flex>{t("Log out")}</Flex>
        </StyledLastMenuItem>
      </StyledMenu>
    </StyledSider>
  );
};

export default SideBar;
